import script from "./TotalModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalModalContent.vue?vue&type=script&setup=true&lang=js"

import "./TotalModalContent.vue?vue&type=style&index=0&id=7cbabc5b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cbabc5b"]])

export default __exports__